import React, { useRef } from "react";
import useIsVisible from "../hooks/useIsVisible";

const FloatingButtons = ({
  failedText,
  successText,
  successDisabled,
  handleFailed = () => {},
  handleSuccess = () => {},
  classNames,
  label,
  submitForm = false,
}) => {
  const ref = useRef();

  const isVisible = useIsVisible(ref);

  return (
    <>
      <div
        ref={ref}
        className={
          classNames ? `${classNames} action-buttons` : "action-buttons"
        }
      >
        <button
          data-button-type="secondary"
          data-action="cancel"
          onClick={(e) => {
            e.preventDefault();
            handleFailed();
          }}
        >
          {failedText}
        </button>
        <button
          data-button-type="primary"
          onClick={handleSuccess}
          disabled={successDisabled}
          type={submitForm ? "submit" : "button"}
          form={submitForm || undefined}
        >
          {successText}
        </button>
      </div>

      {!successDisabled && (
        <div className={isVisible ? "no floating-globe" : "floating-globe"}>
          <p className="p4">{label}</p>
          <div className="action-buttons">
            <button
              data-button-type="secondary"
              data-action="cancel"
              onClick={(e) => {
                e.preventDefault();
                handleFailed();
              }}
            >
              {failedText}
            </button>
            <button
              data-button-type="primary"
              onClick={handleSuccess}
              disabled={successDisabled}
              type={submitForm ? "submit" : "button"}
              form={submitForm || undefined}
            >
              {successText}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FloatingButtons;
